export default __webpack_public_path__ + "static/media/intro.5db5dfdb.mp4";